// @flow

import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { log } from '../../utils/jsUtils';

import { useSelector, useDispatch } from 'react-redux';
import * as R from 'ramda';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';

// import AddProperty from './AddPropertyDialog';
import FilterSearchBox from '../FilterSearchBox';
import HeaderTopBar from '../HeaderTopBar';
import SPBackend, { NOTIFICATION_CHANNELS } from '../../services/SPBackend';
import AddTagDialog from './AddTagDialog';
import AppLoadingSpinner from '../SharedComponents/AppLoadingSpinner';

import { addTag } from '../../reduxStore/modules/tags/actions';
import { useI18n } from '../../contexts/I18nContext';

// import styles from '../Feed/Styles/MemberHeader.Style';
import memberHeaderStyles from '../Feed/Styles/MemberHeader.Style';

import type { Tag } from '../../services/SPBackend';

type Props = {
  mobileOpen: bool,
  usehandleDrawerToggle: Function
};


const TagsHeader = (props: Props) => {
  const {
    usehandleDrawerToggle
  } = props;
  const [openAddTagDialog, setOpenAddTagDialog] = useState(false);
  
  const theme = useTheme();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const i18n = useI18n();

  const handleTagClick = (tag) => {
    // Update the Redux store with the selected tag
    dispatch({ type: 'SELECT_TAG', payload: tag });
  };
  
  const handleAddTag = (tag: Tag, callbackSuccess: Function, callbackFailure: Function) => {
    log('[handleAddTag] tag, user: ', tag, user);

    SPBackend.setTag({
      Name: tag.Name,
      Color: tag.Color
    }, user.user)
      .then(response => {
        const { data } = response;
        const { tag } = data;
        log('[setTag] response: ', data);
        log('[setTag] user: ', user);
        dispatch(addTag(tag, user.user))
        .then(() => {
          if (typeof callbackSuccess !== 'undefined') {
            callbackSuccess();
          }
        })
        .catch((error) => {
          log('[addTag] error: ', error);
          if (typeof callbackFailure !== 'undefined') {
            callbackFailure();
          }
        });
        // dispatch({
        //   type: 'ACTION_SET_IS_APP_LOADING',
        //   isAppLoading: false
        // });
      })
      .catch(e => {
        log('[handlehandleSetTag] e', e);
        if (typeof callbackFailure !== 'undefined') {
          callbackFailure();
        }
        dispatch({
          type: 'ACTION_SET_SNACK_MSG', 
          snackMessage: {
            message: e.message,
            level: 'error',
            duration: 2000
          }
        });
        dispatch({
          type: 'ACTION_SET_IS_APP_LOADING',
          isAppLoading: false
        });
      });

  };

  return (
    <AppBar 
      position="fixed"
      sx={memberHeaderStyles.appBar(theme)}
    >
      <Toolbar
        disableGutters
      >
        <Grid 
          container
          direction='column'
        >
          <HeaderTopBar
            usehandleDrawerToggle={usehandleDrawerToggle}
          >
            <Typography 
              sx={memberHeaderStyles.pageTitle(theme)}
              variant='h3'
            >{i18n.t('Tags')}</Typography>
          </HeaderTopBar>
          <Grid
            item
            sx={{...memberHeaderStyles.rowSub(theme), ...memberHeaderStyles.bottomBar(theme)}}
          >
            <Box 
              sx={memberHeaderStyles.toggleContainer(theme)}
            >
              <Tooltip 
                aria-label={`Add new ${i18n.t('tag')}`}
                title={`Add new ${i18n.t('tag')}`} 
              >
                <Button
                  sx={memberHeaderStyles.navButton(theme)}
                  onClick={() => setOpenAddTagDialog(true)}
                >
                  <i className={'icon-add'} />
                  <Box>{`Add ${i18n.t('Tag')}`}</Box>
                </Button>
              </Tooltip>
            </Box>
          </Grid>
          <AppLoadingSpinner />
        </Grid>
      </Toolbar>
      <AddTagDialog
        open={openAddTagDialog}
        setOpen={setOpenAddTagDialog}
        triggerAction={handleAddTag}
      />
    </AppBar>
  );
};

export default TagsHeader;
